import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide"]
  static values = {
    interval: { type: Number, default: 5 },
    transition: { type: String, default: "fade" }
  }

  connect() {
    this.currentIndex = 0
    this.transitioning = false

    if (this.slideTargets.length <= 1) return

    // Apply transition class to all slides
    this.slideTargets.forEach(slide => {
      slide.classList.add(`transition-${this.transitionValue}`)
    })

    // Start auto-advance
    this.timer = setInterval(() => this.nextSlide(), this.intervalValue * 1000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  nextSlide() {
    if (this.transitioning) return
    this.transitioning = true

    const current = this.slideTargets[this.currentIndex]
    const nextIndex = (this.currentIndex + 1) % this.slideTargets.length
    const next = this.slideTargets[nextIndex]

    // Exit current slide
    current.classList.add("mwc-slide-exit")
    current.classList.remove("mwc-slide-active")

    // Enter next slide
    next.classList.add("mwc-slide-active")

    // Clean up after transition completes
    setTimeout(() => {
      current.classList.remove("mwc-slide-exit")
      this.currentIndex = nextIndex
      this.transitioning = false
    }, 800)
  }
}
